import React, {useState} from 'react';
import {Modal} from "react-bootstrap";
import {IconClose} from "src/components/icons/IconClose";
import styles from "./WarningDxSyc.module.scss";

import {Button} from 'src/components/common/button/Button';

import { useTranslationService } from 'src/services/TranslationService';
import Input from "../../../common/input/Input";

export const WarningDxFca = ({
        onContinue,
        onClose,
    }) => {

    const { t } = useTranslationService();

    const [continueDxFca1, setContinueDxFca1] = useState(false);
    const [continueDxFca2, setContinueDxFca2] = useState(false);
    const [continueDxFca3, setContinueDxFca3] = useState(false);

    return <Modal
        show
        onHide={onClose}
        animated="false"
        className="modal fade in theme-light"
        dialogClassName="modal-md"
        backdropClassName="in"
    >
        <div className="modal-header no-border">
            <span className={styles.title}>{t('new-login.modal-warning-dx-fca.title')}</span>
            <Button variant="no-style" hasIcon className="close" onClick={() => onClose()}>
                <IconClose/>
            </Button>
        </div>
        <div className={styles.modal_body}>
            <div className={styles.content}>
                <p>
                    {t('new-login.modal-warning-dx-fca.description.1')}
                </p>
                <p>
                    {t('new-login.modal-warning-dx-fca.description.2')}
                </p>
                <p>
                    {t('new-login.modal-warning-dx-fca.description.3')}
                </p>
                <p className="dx-mb-7">
                    {t('new-login.modal-warning-dx-fca.description.4')}
                </p>
                <div className="d-flex dx-mb-7">
                    <span className={'flex-shrink-0'}>
                        <Input
                            type={'checkbox'}
                            className={'cursor-pointer'}
                            onChange={e => setContinueDxFca1(e.target.checked)}
                        />
                    </span>
                    <span className={'dx-ml-3'}>
                        {t('new-login.modal-warning-dx-fca.accept.1')}
                    </span>
                </div>
                <div className="d-flex dx-mb-7">
                    <span className={'flex-shrink-0'}>
                        <Input
                            type={'checkbox'}
                            className={'cursor-pointer'}
                            onChange={e => setContinueDxFca2(e.target.checked)}
                        />
                    </span>
                    <span className={'dx-ml-3'}>
                        {t('new-login.modal-warning-dx-fca.accept.2')}
                    </span>
                </div>
                <div className="d-flex dx-mb-7">
                    <span className={'flex-shrink-0'}>
                        <Input
                            type={'checkbox'}
                            className={'cursor-pointer'}
                            onChange={e => setContinueDxFca3(e.target.checked)}
                        />
                    </span>
                    <span className={'dx-ml-3'}>
                        {t('new-login.modal-warning-dx-fca.accept.3')}
                    </span>
                </div>
                <div className="d-flex">
                    <Button variant="outline-secondary" rounded className="dx-ml-auto dx-mr-5" onClick={() => onClose()}>
                        {t('new-login.modal-warning-dx-fca.cancel')}
                    </Button>
                    <Button variant="primary-dark" rounded onClick={() => onContinue()} disabled={!continueDxFca1 || !continueDxFca2 || !continueDxFca3}>
                        {t('new-login.modal-warning-dx-fca.continue')}
                    </Button>
                </div>
            </div>
        </div>
    </Modal>;
};
